/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a DNA sequence above to plot its GC skew.`)
};

const es_gcskew_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una secuencia de ADN arriba para graficar su sesgo GC.`)
};

const de_gcskew_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie oben eine DNA-Sequenz ein, um ihren GC-Skew zu plotten.`)
};

const nl_gcskew_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak hierboven een DNA-sequentie om de GC-skew te plotten.`)
};

const fr_gcskew_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une séquence d'ADN ci-dessus pour tracer son biais GC.`)
};

const it_gcskew_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla una sequenza di DNA sopra per tracciare il suo skew GC.`)
};

const pt_br2_gcskew_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência de DNA acima para plotar seu GC skew.`)
};

const pt_gcskew_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma sequência de ADN acima para representar graficamente a sua assimetria GC.`)
};

const ja_gcskew_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上にDNA配列を貼り付けるとGCスキューがプロットされます。`)
};

const zh_gcskew_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在上方粘贴 DNA 序列以绘制其 GC 偏斜。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_hint_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_hint_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_hint_empty", locale)
	if (locale === "en") return en_gcskew_hint_empty(inputs)
	if (locale === "es") return es_gcskew_hint_empty(inputs)
	if (locale === "de") return de_gcskew_hint_empty(inputs)
	if (locale === "nl") return nl_gcskew_hint_empty(inputs)
	if (locale === "fr") return fr_gcskew_hint_empty(inputs)
	if (locale === "it") return it_gcskew_hint_empty(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_hint_empty(inputs)
	if (locale === "pt") return pt_gcskew_hint_empty(inputs)
	if (locale === "ja") return ja_gcskew_hint_empty(inputs)
	return zh_gcskew_hint_empty(inputs)
};